
  // Shows every duplicate badge whose key (association + matched record id)
  // appears on more than one card, and hides the rest. It re-checks the whole
  // page rather than just this badge, because adding, re-keying or removing one
  // card changes whether the *other* cards with that key are duplicates.
  // LiveView resets `hidden` whenever it re-renders a badge; that re-render is
  // also an `updated()` on the badge, so the check runs again straight after.
  const refresh = () => {
    const badges = document.querySelectorAll("[data-duplicate-key]")
    const counts = new Map()
    badges.forEach(({ dataset: { duplicateKey } }) => {
      counts.set(duplicateKey, (counts.get(duplicateKey) || 0) + 1)
    })
    badges.forEach((badge) => {
      badge.hidden = counts.get(badge.dataset.duplicateKey) < 2
    })
  }

  export default {
    mounted() { refresh() },
    updated() { refresh() },
    // Runs after the badge has left the DOM, so the cards it was paired with
    // lose their badge too.
    destroyed() { refresh() },
  }
